import React from 'react'

const SvgPersonWithLaptop = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M18.075 13c-.62-1.333-1.773-2-3.46-2H9.618c-1.688 0-2.842.667-3.463 2h11.92zM16 6a4 4 0 10-8 0 4 4 0 008 0z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.041 16.4a2 2 0 011.96-2.4h12.04A2 2 0 0120 16.4l-.816 4a2 2 0 01-1.96 1.6H6.816a2 2 0 01-1.96-1.6l-.815-4zm8.963 1.602a1.002 1.002 0 11-2.003 0 1.002 1.002 0 012.003 0z'
    />
  </svg>
)

export default SvgPersonWithLaptop
